import React from "react";
import { FaWallet } from "react-icons/fa";
function GridOverlay1() {
  return (
    <div className="relative h-56 w-72  flex items-center justify-center bg-gray-100">
      {/* Grid Container */}
      <div className="grid grid-cols-2 h-56 w-72 ">
        {/* Grid Items */}
        <div className="bg-white h-full w-full"></div>
        <div className="bg-white h-full w-full"></div>
        <div className="bg-white h-full w-full"></div>
        <div className="bg-white md:bg-customAqua600 lg:bg-customAqua600  h-full w-full"></div>
      </div>

      {/* Overlay Div */}
      <div className="absolute p-4 z-10 w-full h-full rounded-ee-[40px] bg-white  flex flex-col  justify-around text-white font-semibold">
        <FaWallet className="w-10 h-10 text-customAqua100 " />
        <p className="text-lg font-semibold text-customAqua600">Prix abordable</p>
        <p className="font-normal text-sm text-customAqua600">
          Le coût des soins dentaires est raisonnable et gérable dans le cadre
          du budget d'une personne.
        </p>
      </div>
    </div>
  );
}

export default GridOverlay1;
